<template>
    <div class="partingLine"></div>
</template>

<script setup lang="ts">

</script>

<style lang='less' scoped>
@import './index.less';
</style>
